import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Sparkle({ size = 11, color = "var(--tk-gold)", className }: { size?: number; color?: string; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 1 C12.9 8.3 15.7 11.1 23 12 C15.7 12.9 12.9 15.7 12 23 C11.1 15.7 8.3 12.9 1 12 C8.3 11.1 11.1 8.3 12 1 Z"
        fill={color}
      />
    </svg>
  );
}

// Small-caps gold-ink kicker above headlines, optionally framed by sparkles.
export function Eyebrow({
  children,
  sparkles = "both",
  className,
}: {
  children: ReactNode;
  sparkles?: "both" | "start" | "none";
  className?: string;
}) {
  return (
    <div className={cn("tk-eyebrow", className)}>
      {sparkles !== "none" && <Sparkle className="tk-eyebrow__spark" />}
      <span>{children}</span>
      {sparkles === "both" && <Sparkle className="tk-eyebrow__spark" />}
    </div>
  );
}
